import React from 'react';

export const RollerLightGuardsFalse = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 61.6" {...props}>
      <path fill="#fff" d="M4.9.7H90V61H4.9z" />
      <path
        d="M90.1 61.6H4.9c-.4 0-.7-.3-.7-.7V.7c.1-.4.4-.7.7-.7H90c.4 0 .7.3.7.7v60.2c.1.4-.2.7-.6.7zM5.6 60.3h83.8V1.4H5.6v58.9z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M4.9.7H90V61H4.9z" />
      <path
        d="M90.1 61.6H4.9c-.4 0-.7-.3-.7-.7V.7c.1-.4.4-.7.7-.7H90c.4 0 .7.3.7.7v60.2c.1.4-.2.7-.6.7zM5.6 60.3h83.8V1.4H5.6v58.9z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M8.9 4.7h77.2V57H8.9z" />
        <path d="M86.1 57.7H8.9c-.4 0-.7-.3-.7-.7V4.7c0-.4.3-.7.7-.7h77.2c.4 0 .7.3.7.7V57c0 .4-.3.7-.7.7zM9.6 56.3h75.8V5.4H9.6v50.9z" />
      </g>
      <path
        d="M94.4 61.6H.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h93.7c.4 0 .7.3.7.7-.1.4-.4.7-.7.7z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#929497" d="M11.3 4.3h72.3V36H11.3z" />
        <path
          d="M83.9 36.4h-73V4h73v32.4zm-72.3-.7h71.7V4.6H11.6v31.1z"
          fill="#fff"
        />
        <path fill="#929497" d="M10.9 35.5h73v1.1h-73z" />
        <path
          d="M84.1 36.8H10.7v-1.4h73.4v1.4zm-73-.4h72.6v-.7H11.1v.7z"
          fill="#fff"
        />
        <path
          d="M85.3 43.5c-.2 0-.3-.1-.3-.3V42c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .2-.1.3-.3.3zm0-2.4c-.2 0-.3-.1-.3-.3v-1.2c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .1-.1.3-.3.3zm0-2.5c-.2 0-.3-.1-.3-.3V37c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .2-.1.4-.3.4zm0-2.5c-.2 0-.3-.1-.3-.3v-1.2c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .1-.1.3-.3.3zm0-2.5c-.2 0-.3-.1-.3-.3V32c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .2-.1.4-.3.4zm0-2.5c-.2 0-.3-.1-.3-.3v-1.2c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .1-.1.3-.3.3zm0-2.5c-.2 0-.3-.1-.3-.3V27c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .2-.1.4-.3.4zm0-2.5c-.2 0-.3-.1-.3-.3v-1.2c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .1-.1.3-.3.3zm0-2.5c-.2 0-.3-.1-.3-.3V22c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .2-.1.4-.3.4zm0-2.5c-.2 0-.3-.1-.3-.3v-1.2c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .1-.1.3-.3.3zm0-2.5c-.2 0-.3-.1-.3-.3V17c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .2-.1.4-.3.4zm0-2.5c-.2 0-.3-.1-.3-.3v-1.2c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .1-.1.3-.3.3zm0-2.5c-.2 0-.3-.1-.3-.3V12c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .2-.1.4-.3.4zm0-2.5c-.2 0-.3-.1-.3-.3V9.5c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .3-.1.4-.3.4zm0-2.5c-.2 0-.3-.1-.3-.3V7c0-.2.1-.3.3-.3s.3.1.3.3v1.2c0 .3-.1.4-.3.4z"
          fill="#929497"
        />
        <path fill="#929497" d="M9.6 4.3h76.7v3.4H9.6z" />
        <path
          d="M86.6 8H9.2V4h77.3l.1 4zM9.9 7.4h76V4.6h-76v2.8z"
          fill="#fff"
        />
        <g>
          <path
            d="M85.3 3.3c.7 0 1.4.6 1.4 1.3v2.8c0 .7-.6 1.3-1.3 1.3-.7 0-1.4-.6-1.4-1.3V4.6c-.1-.7.5-1.3 1.3-1.3z"
            fill="#929497"
          />
          <path
            d="M85.3 9c-.9 0-1.6-.7-1.6-1.6V4.6c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6v2.8c0 .9-.7 1.6-1.6 1.6zm0-5.5c-.6 0-1.1.5-1.1 1.1v2.8c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1V4.6c-.1-.6-.5-1.1-1.1-1.1z"
            fill="#fff"
          />
        </g>
        <g>
          <path
            d="M9.6 3.3c.7 0 1.4.6 1.4 1.3v2.8c0 .7-.6 1.3-1.3 1.3-.7 0-1.4-.6-1.4-1.3V4.6c-.1-.7.5-1.3 1.3-1.3z"
            fill="#929497"
          />
          <path
            d="M9.6 9c-.9 0-1.7-.7-1.7-1.6V4.6c0-.9.8-1.6 1.7-1.6.9 0 1.6.7 1.6 1.6v2.8c0 .9-.7 1.6-1.6 1.6zm0-5.5c-.6 0-1.1.5-1.1 1.1v2.8c0 .6.5 1 1.1 1 .6 0 1.1-.5 1.1-1.1V4.6c-.1-.6-.5-1.1-1.1-1.1z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
